import { ClinicGlobalStore } from '../../store/clinic-global.store';

import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ExternalLinksConstants } from '@web/csl-lib-constants';
import { GlobalStore } from '@web/csl-lib-store';
import { LoginService } from '@web/csl-lib-services';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { TooltipModule } from 'primeng/tooltip';


@Component({
  selector: 'app-clinic-site-header',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './clinic-site-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './clinic-site-header.component.css',
})
export class ClinicSiteHeaderComponent implements OnInit {
  private msalGuardConfig = inject<MsalGuardConfiguration>(MSAL_GUARD_CONFIG);
  private msalService = inject(MsalService);
  private loginService = inject(LoginService);

  /* Store */

  globalStore = inject(GlobalStore);
  clinicGlobalStore = inject(ClinicGlobalStore);

  /* Services */

  /* Member Vars */
  private isLoggingOut = false;

  // Build the logoUrl using the ButterCMS image API to resize the image
  logoUrl= computed(() => {
    if(this.clinicGlobalStore.clinic()) {
      return this.clinicGlobalStore.clinic()?.logoUrl?.replace(/(https?:\/\/[^\/]+)(\/.*)/, '$1/resize=height:60$2');
    }
    return null;
  });

  ngOnInit() {
    this.loginService.claims$.subscribe((c) => {
      this.globalStore.setClaims(c);
    });
  }

  protected readonly ExternalLinksConstants = ExternalLinksConstants;

  /* Event Handlers */

  /* Instance Methods */

  async logout() {
    if (this.isLoggingOut) return; // Prevent double-clicks

    try {
      this.isLoggingOut = true;

      // Use the enhanced logout with token blocking
      await this.loginService.logoutWithTokenBlock(false); // Single device logout

    } catch (error) {
      console.error('Logout error:', error);
      this.isLoggingOut = false;

      const account = this.msalService.instance.getActiveAccount();

      if (!account?.idToken) {
        // No cached account/ID token to populate id_token_hint from - B2C cannot
        // validate postLogoutRedirectUri without it, so skip B2C's logout endpoint
        // entirely rather than risk landing on a B2C error page. Just clear local
        // state and go straight to the same destination a successful logout would.
        await this.msalService.instance.clearCache();
        window.location.href = environment.logoutRedirectUrl;
        return;
      }

      // Fallback to original logout if enhanced logout fails
      // Note: MSAL does NOT derive idTokenHint from `account` automatically - it must be
      // passed explicitly, using the raw ID token cached on the account, for B2C to validate
      // postLogoutRedirectUri against the app's registered redirect URIs.
      const logoutRequest = {
        account,
        idTokenHint: account.idToken,
        postLogoutRedirectUri: environment.logoutRedirectUrl,
        mainWindowRedirectUri: environment.logoutRedirectUrl,
      };
      this.msalService.logoutRedirect(logoutRequest);
    }
  }


}
